//Subaction constants which are changed

export const STATION = "station";
export const LOCATION = "location";
export const ATA = "ata";
export const ADV = "adv";
export const ETR = "etr";
export const OTS_START_TIME = "otstime";
export const PROBLEM_TEXT = "problemtext";
export const OTS_RETURN_TO_SERVICE = "otsreturntoservice";
export const OTS_RETURN_TO_SERVICE_EDIT = "otsreturntoserviceedit";
export const OTS_REOPEN = "otsreopen";
export const EVENT_TYPE_CHANGE = "changeeventtypecategory";
export const SPECIAL_EVENT = "specialevent";
